import * as React from "react";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { ISize } from "../../interfaces/dropdown-sizes-types";
import { $, merge } from "glamor";
import theme from "styles/theme";

interface ICheckboxLisItemProps {
    item: ISize;
    onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const styles = merge(
    $(" .MuiCheckbox-colorSecondary.Mui-checked", {
        color: theme.palette.accent1Color,
    })
);

export const CheckboxLisItem: React.FC<ICheckboxLisItemProps> = ({ item, onCheckboxChange }) => {
    return (
        <div {...styles}>
            <FormControlLabel
                key={item.id}
                control={<Checkbox checked={item.selected} onChange={onCheckboxChange} value={item.title} />}
                label={item.title}
            />
        </div>
    );
};
